import MUIDataTable from "mui-datatables";
import { styled } from '@mui/material/styles';
import { getColorFromSlug } from "utility/colors";
import { screenWidth } from "utility/screen-width";

// https://mui.com/material-ui/customization/how-to-customize/#2-reusable-component
export const StyledDataTable = styled(MUIDataTable)`
    box-shadow: none;
    border-radius: 0;

    .MuiToolbar-root {
        padding: 0;
        min-height: 48px;
    }

    table:not([class*="MUIDataTableFooter-root"]) {
        border-top: 1px solid ${getColorFromSlug('david-black')};
        border-left: 1px solid ${getColorFromSlug('david-black')};
        border-right: 1px solid ${getColorFromSlug('david-black')};

        tr {
            border: 0;
        }

        th, td {
            color: ${getColorFromSlug('david-black')};
            /* border-right: 1px solid ${getColorFromSlug('david-black')}; */
            border-bottom: 1px solid ${getColorFromSlug('david-black')};
            font-family: 'Source Sans Pro',sans-serif;
            font-size: 16px;
            font-weight: 400;
            line-height: 1.2;
            color: ${getColorFromSlug('david-black')};

            &.text-center {
                text-align: center;
            }

            .table-row-actions-container {
                display: flex;
                align-items: center;
                gap: 8px;

                >*:not(:last-child) {
                    margin-right: 5px;
                }
                
                @media ${screenWidth.below.lg} {
                    flex-wrap: wrap;   
                }
            }
        }
    
        td {
            padding: 10px 15px;
        }
    
        th {
            background: ${getColorFromSlug('david-yellow')};
            font-family: 'Oswald',serif;
            font-size: 20px;
            line-height: 1.2;
            font-weight: 500;
            padding: 0;
    
            /**
             * This handles header cells that are not sortable (no button).
             */
            >:not([class*="MUIDataTableHeadCell-contentWrapper"]) {
                padding: 10px 15px;
            }
    
            .MuiButton-root {
                width: 100%;
                justify-content: start;
                font-family: 'Oswald',serif;
                font-size: 18px;
                line-height: 1.2;
                font-weight: 500;
                text-transform: none;
                border-radius: 0;
                padding: 10px 15px;
    
                >[class*="MUIDataTableHeadCell-sortAction"] {
                    align-items: center;
    
                    >[class*="MUIDataTableHeadCell-sortAction"] {
                        display: flex;
                        justify-content: flex-end;
                        width: 22px;

                        svg[class*="MuiTableSortLabel-icon"] {
                            margin: 0;
                        }
                    }
                }
            }

            /**
             * Keep text centered even when sorting icon exists on right side.
             */
            &.text-center {
                .MuiButton-root {
                    padding-left: 37px;
                }
            }
        }
    }

    table[class*="MUIDataTableFooter-root"] {
        td {
            border-bottom: 0;
            padding: 0;
        }
    }

    @media ${screenWidth.is.sm} {
        table:not([class*="MUIDataTableFooter-root"]) {
            thead {
                display: none;
            }

            tr {
                display: block;
            }

            th, td {
                display: flex;
                text-align: left !important;
            }

            td {
                &:not(:last-child) {
                    border-bottom: 1px solid #ddd;
                }

                >*[class*="MUIDataTableBodyCell-simpleHeader"] {
                    flex-shrink: 0;
                    display: inline-block;
                    font-weight: bold;
                    width: 100px;
                    box-sizing: border-box;
                    padding-right: 15px;
                }

                >*[class*="MUIDataTableBodyCell-simpleCell"] {
                    flex-grow: 1;
                    display: inline-block;
                    width: auto;
                    box-sizing: border-box;
                }
            }
        }
    }

    @media ${screenWidth.below.sm} {
        table:not([class*="MUIDataTableFooter-root"]) {
            thead {
                display: none;
            }

            tr, th, td {
                display: block;
                text-align: left !important;
            }

            td {
                &:not(:last-child) {
                    border-bottom: 1px solid #ddd;
                }

                >*[class*="MUIDataTableBodyCell-simpleHeader"] {
                    display: inline-block;
                    font-weight: bold;
                    width: 100%;
                    box-sizing: border-box;
                    margin-bottom: 3px;
                }

                >*[class*="MUIDataTableBodyCell-simpleCell"] {
                    display: inline-block;
                    width: 100%;
                    box-sizing: border-box;
                }
            }
        }

        table[class*="MUIDataTableFooter-root"] {
            tfoot {
                td.MuiTableCell-footer {
                    >*[class*="MUIDataTablePagination-navContainer"] {
                        display: flex;
                        justify-content: center;
    
                        .MuiTablePagination-toolbar {
                            justify-content: center;
                            flex-wrap: wrap;
    
                            /**
                             * This will allow us to force a break in the flex items.
                             * Mark the items you want after it with 'order:2'.
                             * https://stackoverflow.com/a/29733127
                             */
                            &:before {
                                content: '';
                                width: 100%;
                                flex-shrink: 0;
                                order: 1;
                            }

                            *[class*="MuiTablePagination-select"] {
                                margin-right: 0;
                            }

                            .MuiTablePagination-displayedRows,
                            .MuiTablePagination-actions {
                                order: 2;
                            }
                        }
                    }
                }
            }
        }
    }
`;
